import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import classNames from 'classnames';
import Icon from "../../wui-icon/src";
import PropTypes from "prop-types";
import { Col } from '../../wui-layout/src/index.js';
import Popover from '../../wui-popover/src/index.js';
import { FormContext, FormItemPrefixContext } from './context';
import ErrorList from './ErrorList';
import { set } from 'lodash'; // export interface FormItemInputProps {
//   wrapperCol?: ColProps;
//   help?: React.ReactNode;
//   extra?: React.ReactNode;
//   status?: ValidateStatus;
// }

var iconMap = {
  success: /*#__PURE__*/React.createElement(Icon, {
    type: "uf-correct"
  }),
  warning: /*#__PURE__*/React.createElement(Icon, {
    type: "uf-exc-t"
  }),
  error: /*#__PURE__*/React.createElement(Icon, {
    type: "uf-exc-c"
  }),
  validating: /*#__PURE__*/React.createElement(Icon, {
    type: "uf-i-c-2"
  })
};

var FormItemInput = function FormItemInput(props) {
  var prefixCls = props.prefixCls,
      status = props.status,
      wrapperCol = props.wrapperCol,
      children = props.children,
      help = props.help,
      errors = props.errors,
      onDomErrorVisibleChange = props.onDomErrorVisibleChange,
      hasFeedback = props.hasFeedback,
      formItemRender = props._internalItemRender,
      validateStatus = props.validateStatus,
      extra = props.extra;
  var baseClassName = "".concat(prefixCls, "-item");
  var formContext = React.useContext(FormContext);
  var mergedWrapperCol = wrapperCol || formContext.wrapperCol || {};
  var className = classNames("".concat(baseClassName, "-control"), mergedWrapperCol.className);
  React.useEffect(function () {
    return function () {
      onDomErrorVisibleChange(false);
    };
  }, []); // Should provides additional icon if `hasFeedback`

  var IconNode = validateStatus && iconMap[validateStatus];
  var icon = hasFeedback && IconNode ? /*#__PURE__*/React.createElement("span", {
    className: "".concat(baseClassName, "-children-icon")
  }, /*#__PURE__*/React.createElement(IconNode, null)) : null; // Pass to sub FormItem should not with col info

  var subFormContext = _objectSpread({}, formContext);

  delete subFormContext.labelCol;
  delete subFormContext.wrapperCol;
  var isError = errors.length > 0;
  var errorInputBorder = isError ? "error-input" : "";
  var inputDom = /*#__PURE__*/React.createElement("div", {
    className: "".concat(baseClassName, "-control-input ").concat(errorInputBorder)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(baseClassName, "-control-input-content")
  }, children), icon);
  var errorListDom = isError ? /*#__PURE__*/React.createElement(FormItemPrefixContext.Provider, {
    value: {
      prefixCls: prefixCls,
      status: status
    }
  }, /*#__PURE__*/React.createElement(ErrorList, {
    errors: errors,
    help: help,
    onDomErrorVisibleChange: onDomErrorVisibleChange
  })) : null; // If extra = 0, && will goes wrong
  // 0&&error -> 0

  var extraDom = extra ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(baseClassName, "-extra")
  }, extra) : null;
  var dom = formItemRender && formItemRender.mark === 'pro_table_render' && formItemRender.render ? formItemRender.render(props, {
    input: inputDom,
    errorList: errorListDom,
    extra: extraDom
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popover, {
    content: errorListDom,
    trigger: ["hover", "focus"]
  }, inputDom), extraDom);
  return /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: subFormContext
  }, /*#__PURE__*/React.createElement(Col, _extends({}, mergedWrapperCol, {
    className: className
  }), dom));
};

FormItemInput.propTypes = {
  prefixCls: PropTypes.string,
  children: PropTypes.any,
  errors: PropTypes.array,
  hasFeedback: PropTypes.bool,
  validateStatus: PropTypes.oneOf(['success', 'warning', 'error', 'validating', '']),
  onDomErrorVisibleChange: PropTypes.func
};
export default FormItemInput;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-form/src/FormItemInput.js